
<template>
<div id="agWsPage">

    <!-- loading spinner or no workspaces -->
    <b-spinner v-if="isLoading" id="agWsPage-loadingSpinner"></b-spinner>
    <div id="agWsPage-noWss" v-else-if="workspaces.length == 0">
      <fa icon="briefcase"/>
      <div>No workspaces have been created</div>
    </div>


    <!-- workspace modal -->
    <ag-workspace-modal
      ref="workspaceModal"
      :workspace="modalWorkspace"
      @reloadWorkspaces="reloadWorkspaces">
    </ag-workspace-modal>

    <!-- workspace delete modal -->
    <b-modal
      ref="deleteModal"
      id="agWsPage-deleteModal"
      class="agModal"
      centered
      no-close-on-esc
      no-close-on-backdrop
      @keyup.enter.native="deleteWsButton_click">
      <template slot="modal-header">
        <h4 class="agModal-title danger">Delete Workspace</h4>
      </template>
      Are you sure you want to delete workspace
      <i>{{modalWorkspace.name}}</i>?
      <template slot="modal-footer" slot-scope="{cancel}">
        <b-button class="agModal-buttonLeft" @click="cancel">Cancel</b-button>
        <b-button
          class="agModal-buttonRight"
          variant="danger"
          @click="deleteWsButton_click"
        >Delete</b-button>
      </template>
    </b-modal>


    <!-- toolbar -->
    <ag-toolbar>
        <template slot="leftContent">
            <b-button 
                class="agImageButton" 
                :disabled="isReadonly || isLoading"
                v-b-tooltip.hover
                title="Add workspace"
                @click="addWsButton_click">
                <fa icon="plus"/>
            </b-button>
      </template>
    </ag-toolbar>

    <!-- workflows -->
    <b-card id="agWsPage-wss" v-if="!isLoading && sortedWorkspaces.length > 0" :key="reload">
    <draggable v-model="sortedWorkspaces" handle=".card-header" ghost-class="agWs-ghost">
        <ag-workspace
            v-for="workspace in sortedWorkspaces"
            :key="workspace._id"
            :workspace="workspace"
            @editWorkspace="editWorkspace"
            @deleteWorkspace="deleteWorkspace"
            @reloadWorkspaces="reloadWorkspaces">
        </ag-workspace>
    </draggable>
    </b-card>

</div>
</template>






<script>

// components
import Toolbar from "comp/ui/Toolbar";
import Workspace from "comp/workspace/Workspace";
import WorkspaceModal from "comp/workspace/WorkspaceModal";


// modules
import Server from "src/server";
import Util from "src/util/util";
import Draggable from "vuedraggable";

import User from '../../store/user'


export default {
    name: "ag-workspaces-page",
    components: {
        "ag-toolbar": Toolbar,
        "ag-workspace": Workspace,
        "ag-workspace-modal": WorkspaceModal,
        draggable: Draggable,
    },
    props:{
        
    },
    data(){
        return {
            reload: 0,
            isDeleting: false,
            modalWorkspace: {
                name: "",
                description: "",
                owner: this.user,
                users: [],
                groups: []
            },
            sortedWorkspaces: [],
        };
    },
    computed: {

        isLoading() {
            if(this.$store.state.wsStore.isLoading || this.isDeleting)
                return true;
            return false;
        },

        isReadonly() {
            if(this.user.role == "readonly")
                return true;
            return false;
        },

        user() {
            return this.$store.state.userStore.user;
        },

        workspaces:
        {
            // explicity define getter/setter so that draggable component updates store
            get() {
                return this.$store.state.wsStore.workspaces;
            },
            set(value) {
                this.$store.state.wsStore.workspaces = value;
            }    
        }
    },
    watch: {
        workspaces() {
            this.setSortedWorkspaces();
        },

        sortedWorkspaces(oldList, newList) {
            if (
                !!newList &&
                !!oldList &&
                oldList.length > 0 &&
                newList.length > 0 &&
                JSON.stringify(oldList) != JSON.stringify(newList)
            )
            this.saveWorkspaceOrder();
        }
    },

    created() {

    },

    mounted() {
      this.setSortedWorkspaces();
    },

    methods: {

        // UI Events

        addWsButton_click() {
            this.resetModalWorkspace();
            this.$refs.workspaceModal.show();
        },

        async deleteWsButton_click()
        {
            this.$refs.deleteModal.hide();
            this.isDeleting = true;
            await this.$store.dispatch("wsStore/deleteWorkspace", {workspace: this.modalWorkspace});
            this.isDeleting = false;
            this.resetModalWorkspace();
        },
        

        // emitted Events

        editWorkspace(workspace) {
            this.modalWorkspace = Util.copyObject(workspace);
            setTimeout(() => {
                this.$refs.workspaceModal.show();
            }, 250);
        },

        deleteWorkspace(workspace) {
            this.modalWorkspace = Util.copyObject(workspace);
            this.$refs.deleteModal.show();
        },

        reloadWorkspaces(){
            this.setSortedWorkspaces();
            this.reload++;
        },


        // other

        resetModalWorkspace()
        {
            this.modalWorkspace = {
                name: "",
                description: "",
                owner: this.user,
                users: [],
                groups: []
            };
        },

        setSortedWorkspaces() {
            // console.log("user data ",User.state.user);
            this.sortedWorkspaces = [];
            if (this.workspaces.length == 0) {
                return;
            }

            var remaining = Util.copyArray(this.workspaces);
            // sort by user parm
            var order = this.user.parms.workspaces;
            console.log("ar ",order);
            if (order) {
                for (var i = 0; i < order.length; i++) {
                    if(User.state.user.role == 'user'){
                        var workspace = remaining.find(a => a._id == order[i].workspace);
                    if (workspace) {
                        this.sortedWorkspaces.push(workspace);
                        remaining = Util.removeFromArrayByKey(
                            remaining,
                            "_id",
                            workspace._id
                        );
                    }
                    }else{
                        var workspace = remaining.find(a => a._id == order[i].workspace);
                    if (workspace) {
                        this.sortedWorkspaces.push(workspace);
                        remaining = Util.removeFromArrayByKey(
                            remaining,
                            "_id",
                            workspace._id
                        );
                    }
                    // add remaining
                for (var i = 0; i < remaining.length; i++) {
                    this.sortedWorkspaces.unshift(remaining[i]);
                }
                    }
                }
            }
        },

        saveWorkspaceOrder() {
            if (!this.user.parms.workspaces) 
                this.user.parms.workspaces = [];

            var remaining = Util.copyArray(this.sortedWorkspaces);
            var order = [];
            for (var i = 0; i < this.sortedWorkspaces.length; i++) {
                var workspace = this.sortedWorkspaces[i];
                var existing = this.user.parms.workspaces.find(a => a.workspace == workspace._id);
                if(!existing) {
                    existing = {
                        workspace: workspace._id,
                        workflows: [],
                        connections: []
                    };
                }
                order.push(existing);
            }
            this.user.parms.workspaces = order;

            this.$store.dispatch("userStore/updateUserParms", { user: this.user });
        }
    }
}

</script>






<style scoped lang="css">

  #agWsPage-wss {
    position: relative;
    height: calc(100vh - 150px);
    top: 65px;
    overflow: auto;
  }

#agWsPage-loadingSpinner {
    position: absolute;
    width: 50px;
    height: 50px;
    left: 50%;
    top: 50%;
    margin-left: -20px;
    margin-top: -20px;
  }

  #agWsPage-noWss
  {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -277.0px;
    margin-top: -61.0px;
    font-size: 36px;
    color: lightgray;
  }

  #agWsPage-noWss svg
  {
    font-size: 60px;
  }



</style>



// WEBPACK FOOTER //
// src/components/workspace/WorkspacesPage.vue